import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-template2',
  templateUrl: './template2.component.html',
  styleUrls: ['./template2.component.scss']
})
export class Template2Component implements OnInit {

  template2Pie = {
    labels: ['January','February','March'],
    datasets: [
    {
        data: [300, 50, 100],
        backgroundColor: [
            "#FF6384",
            "#36A2EB",
            "#FFCE56"
        ],
        hoverBackgroundColor: [
            "#FF6384",
            "#36A2EB",
            "#FFCE56"
        ]
    }]
  }
  template2Line = {
    labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
    datasets: [
        {
            label: 'First Dataset',
            data: [65, 59, 80, 81, 56, 55, 40],
            fill: false,
            borderColor: '#4bc0c0'
        },
        {
            label: 'Second Dataset',
            data: [28, 48, 40, 19, 86, 27, 90],
            fill: false,
            borderColor: '#565656'
        }
    ]
  }
  template1BarData = [
    {
      "id":1,
      "name":"test1",
      "code":"test1",
      "category":"test1",
      "quantity":"test1"
    },
    {
      "id":2,
      "name":"test2",
      "code":"test2",
      "category":"test2",
      "quantity":"test2"
    },
    {
      "id":3,
      "name":"test3",
      "code":"test3",
      "category":"test3",
      "quantity":"test3"
    },
    {
      "id":4,
      "name":"test4",
      "code":"test4",
      "category":"test4",
      "quantity":"test4"
    },
    {
      "id":5,
      "name":"test5",
      "code":"test5",
      "category":"test5",
      "quantity":"test5"
    },
    {
      "id":6,
      "name":"test6",
      "code":"test6",
      "category":"test6",
      "quantity":"test6"
    },
    {
      "id":7,
      "name":"test7",
      "code":"test7",
      "category":"test7",
      "quantity":"test7"
    },
  ]
  
  displayPieDetail = false;
  selectedPieData;
  selectedPieLabel;

  constructor() { }

  ngOnInit(): void {
  }

  selectPieData(event) {
    this.displayPieDetail = true;
    this.selectedPieData = this.template2Pie.datasets[event.element._datasetIndex].data[event.element._index];
    this.selectedPieLabel = this.template2Pie.labels[event.element._index];
  }

}
